module.exports = __webpack_public_path__ + "img/img_047@2x.df598655.png";